import { RecentComplaints } from "../../../components/recent-complaints";
import { CalendarDateRangePicker } from "../../../components/date-range-picker";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import { ScrollArea } from "../../../components/ui/scroll-area";
import { Tabs, TabsContent } from "../../../components/ui/tabs";
import { Frame, GalleryVerticalEnd, Users } from "lucide-react";
import { TriangleAlert } from "lucide-react";
import { useEffect, useState } from "react";
import {
  getAllStats,
  getRecentMessages,
} from "../../../API/Admin/adminService";
import { Link } from "react-router-dom";

export default function page() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [stats, setStats] = useState<any>();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [messages, setMessages] = useState<any[]>([]);

  const fetchStats = async () => {
    try {
      const response = await getAllStats();
      const messages = await getRecentMessages();
      if (response) {
        setStats(response);
      }
      if (messages) {
        setMessages(messages);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
    }
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    fetchStats();
  }, []);
  return (
    <ScrollArea className="h-full">
      <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
        <div className="flex items-center justify-between space-y-2">
          <h2 className="text-3xl font-bold tracking-tight">Bonjour 👋</h2>
          <div className="items-center hidden space-x-2 md:flex">
            <CalendarDateRangePicker />
          </div>
        </div>
        <Tabs defaultValue="overview" className="space-y-4">
          <TabsContent value="overview" className="space-y-4">
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
              <Link to="/admin-dashboard/utilisateurs">
                <Card className="group hover:bg-primary">
                  <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
                    <CardTitle className="text-sm font-medium group-hover:text-white">
                      <div className="p-2 group-hover:text-white">
                        Nombre d'utilisateurs{" "}
                      </div>
                    </CardTitle>
                    <div className="p-2">
                      <Users className="group-hover:text-white" />
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="text-2xl font-bold group-hover:text-white">
                      {stats?.users}
                    </div>
                  </CardContent>
                </Card>
              </Link>
              <Link to="/admin-dashboard/messages">
                <Card className="group hover:bg-primary">
                  <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
                    <CardTitle className="text-sm font-medium">
                      <div className="p-2 group-hover:text-white">
                        Nombre des messages{" "}
                      </div>
                    </CardTitle>
                    <div className="p-2">
                      <TriangleAlert className="group-hover:text-white" />
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="text-2xl font-bold group-hover:text-white">
                      {stats?.messages}
                    </div>
                  </CardContent>
                </Card>
              </Link>
              <Link to="/admin-dashboard/travaux">
                <Card className="group hover:bg-primary">
                  <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
                    <CardTitle className="text-sm font-medium">
                      <div className="p-2 group-hover:text-white">
                        Travaux en cours
                      </div>
                    </CardTitle>
                    <div className="p-2">
                      <Frame className="group-hover:text-white" />
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="text-2xl font-bold group-hover:text-white">
                      {" "}
                      {stats?.projects}
                    </div>
                  </CardContent>
                </Card>
              </Link>
              <Link to="/admin-dashboard/candidatures-emploi">
                <Card className="group hover:bg-primary">
                  <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
                    <CardTitle className="text-sm font-medium">
                      <div className="p-2 group-hover:text-white">
                        Nombre des candidatures{" "}
                      </div>
                    </CardTitle>
                    <div className="p-2">
                      <GalleryVerticalEnd className="group-hover:text-white" />
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="text-2xl font-bold group-hover:text-white">
                      {stats?.applications}
                    </div>
                  </CardContent>
                </Card>
              </Link>
            </div>
            <div className="">
              <Card className="">
                <CardHeader>
                  <CardTitle>
                    {" "}
                    <div className="p-2">Derniers messages</div>
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <RecentComplaints complaints={messages} />
                </CardContent>
              </Card>
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </ScrollArea>
  );
}
